import { render, staticRenderFns } from "./HalfImage.vue?vue&type=template&id=23963862"
import script from "./HalfImage.vue?vue&type=script&lang=js"
export * from "./HalfImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports